module.exports = __webpack_public_path__ + "media/images/icons/remove-b6107df3b53abb1f1e82797b311b9afd.svg";